import { type } from 'ramda';
import { log } from 'log';

const safeFetch = (url, options) => new Promise((res, rej) => {
    let timeout;

    if (options?.requestTimeout) {
        timeout = setTimeout(() => rej(`Request timeout ${url}`), options.requestTimeout);
    }

    window.fetch(url, options)
        .then(res, rej)
        .finally(() => clearTimeout(timeout));
});

const parseJSONData = async (res) => {
    const data = await res.text();

    try {
        return JSON.parse(data);
    } catch {
        return data;
    }
};

const parseXMLData = async (res) => {
    const data = await res.text();

    try {
        return new window.DOMParser().parseFromString(data, 'text/xml');
    } catch {
        return data;
    }
};

const getWithParser = parseData => url => {
    log('httpReq', { url });
    const timestamp = new Date();
    const getTime = () => new Date() - timestamp;

    return safeFetch(url)
        .then(async (res) => {
            const data = await parseData(res);
            const logType = res.ok ? 'httpRes' : 'httpErr';

            log(logType, { url, data, time: getTime() });

            return res.ok
                ? data
                : Promise.reject(res);
        })
        .catch((error) => {
            log('httpErr', { url, error, time: getTime() });

            return Promise.reject(error);
        });
};

export const get = getWithParser(parseJSONData);
export const getXML = getWithParser(parseXMLData);

/**
 * @function
 * @param [url] {string}
 * @param {Object}
 */
export const getWithMock = (url, { successResponse, errorResponse } = {}) => {
    if (errorResponse) {
        return Promise.reject(errorResponse);
    } else if (successResponse) {
        return Promise.resolve(successResponse);
    }

    return get(url);
};

export const post = ({ url, headers = {}, requestBody = {}, requestOptions = {} }) => {
    if (!url) {
        return Promise.reject('No "url" argument');
    } else if (type(headers) !== 'Object' && type(requestBody) !== 'Object') {
        return Promise.reject('"headers" or "requestBody" not object');
    }

    const logMessage = { url, method: 'post' };
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...headers
        },
        ...requestOptions,
        body: JSON.stringify(requestBody)
    };

    const timestamp = new Date();
    const getTime = () => new Date() - timestamp;
    log('httpReq', {
        ...logMessage,
        ...options,
        requestBody
    });

    return safeFetch(url, options)
        .then(async (res) => {
            const data = await parseJSONData(res);

            if (res.ok) {
                log('httpRes', { ...logMessage, data, time: getTime() });
                return data;
            }

            return Promise.reject(data);
        })
        .catch((error) => {
            log('httpErr', { ...logMessage, error, time: getTime() });

            return Promise.reject(error);
        });
};

export default safeFetch;
